export function buildNodeUri(nodeId) {
  return `quilt://node/${nodeId}`;
}

export function buildEdgeUri(edgeId) {
  return `quilt://edge/${edgeId}`;
}

export function parseQuiltUri(raw) {
  const value = (raw || "").trim();
  const match = /^quilt:\/\/(node|edge)\/([A-Za-z0-9_-]+)$/i.exec(value);
  if (!match) return null;
  return {
    refType: match[1].toLowerCase(),
    id: match[2],
  };
}
